import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";

export const CIRCLE_TILE_IMAGE_SIZE_PIXELS: ResponsiveValues<number> = {
  mobileAndAbove: 80,
  tabletAndAbove: 88,
};

export const CIRCLE_TILE_WIDTH_PIXELS: ResponsiveValues<number> = {
  mobileAndAbove: 104,
  tabletAndAbove: 112,
  desktopAndAbove: 124,
};
